import { TextField } from '@tmov/design-system';
import { Search } from '@tmov/design-system/icons';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { useFiltro } from '../../../../../../../../contexts/FilaEmbarque/Filtro/hooks/useFiltro';
import {
  formatarPlaca,
  removeCaracteresEspeciais,
} from '../../../../../../../../helpers/formatador';
import { formatToCPF } from '../../../../../../../../helpers/formatToCPF';
import { Container } from './styles';

export default function ViagemInputs({ handleText }) {
  const { filtro } = useFiltro();
  const { placa, cpf, nomeMotorista } = filtro.filtrosDrawer;
  const [focusController, setFocusController] = useState({
    placa: false,
    motorista: false,
  });

  const handleOnChange = (value, name) => {
    handleText({ [name]: value });
  };

  const handleFocusBlur = tipo => {
    setFocusController(prevState => ({
      ...prevState,
      [tipo]: !prevState[tipo],
    }));
  };

  const handlePlacaInput = event => {
    const { value } = event.target;

    handleOnChange(value, 'placa');
  };

  const handleMotoristaInput = event => {
    const { value } = event.target;
    const isNumber = /^[0-9]+$/;
    const isString = /[\s\S]/g;

    const valueLimpo = removeCaracteresEspeciais(value);

    if (valueLimpo.match(isNumber)) {
      handleOnChange(valueLimpo, 'cpf');
    } else if (valueLimpo.match(isString) && cpf.length === 0) {
      handleOnChange(valueLimpo, 'nomeMotorista');
    }

    if (valueLimpo.length === 0) {
      handleOnChange('', 'cpf');
      handleOnChange('', 'nomeMotorista');
    }
  };

  return (
    <Container>
      <TextField
        data-testid="placa"
        value={formatarPlaca(placa)}
        label={`${focusController.placa ? 'Placa' : 'Busca por placa'}`}
        trailingIcon={Search}
        onFocus={() => handleFocusBlur('placa')}
        onBlur={() => handleFocusBlur('placa')}
        onChange={event => handlePlacaInput(event)}
      />
      <TextField
        data-testid="motorista"
        value={cpf ? formatToCPF(cpf.toString()) : nomeMotorista}
        label={`${
          focusController.motorista
            ? 'Motorista'
            : 'Buscar motorista por nome ou CPF'
        }`}
        trailingIcon={Search}
        onFocus={() => handleFocusBlur('motorista')}
        onBlur={() => handleFocusBlur('motorista')}
        onChange={event => handleMotoristaInput(event)}
      />
    </Container>
  );
}

ViagemInputs.propTypes = {
  handleText: PropTypes.func.isRequired,
};
